import { Observable } from 'rxjs';
import { Cuotas } from '../interfaces/cuotas';
import { CuotasResponse } from '../interfaces/cuotas-response';



export abstract class CuotasService {

    abstract getCuotas(): Observable<CuotasResponse>;

    abstract postCuotas(cuotas: Cuotas): Observable<any>;

}
